const modules = {
    "[data-accordion]": () => import("./modules/accordion"),
    // "[data-announcement]": () => import("./modules/announcement"),
    "[data-column-pin]": () => import("./modules/columnPin"),
    "[data-contact-pin]": () => import("./modules/contactPin.js"),
    "[data-content-tabs]": () => import("./modules/tabs"),
    "[data-draw-icons]": () => import("./modules/iconDraw"),
    "[data-fade-pins]": () => import("./modules/fadePins"),
    "[data-graphic]": () => import("./modules/transitions/graphic"),
    "[data-img-accordion]": () => import("./modules/imgAccordion"),
    "[data-lightbox-toggle]": () => import("./modules/lightbox"),
    "[data-lite-yt-embed]": () => import("./modules/liteYouTube"),
    "[data-lottie]": () => import("./modules/lottie"),
    "[data-mobile-navigation]": () => import("./modules/mobileNavigation"),
    "[data-mobile-topics]": () => import("./modules/mobileTopics"),
    "[data-pin-content]": () => import("./modules/pins"),
    "[data-projects]": () => import("./modules/projects"),
    "[data-projects-mobile]": () => import("./modules/projectsMobile"),
    "[data-reveal]": () => import("./modules/reveal.js"),
    "[data-slider]": () => import("./modules/slider.js"),
    "[data-social-share]": () => import("./modules/socialShare"),
    "[data-swiper]": () => import("./modules/swiper"),
    "[data-swiper-carousel]": () => import("./modules/swiperCarousel"),
    "[data-transcript]": () => import("./modules/transcript"),
    "[data-video]": () => import("./modules/videoBackground"),
    "[data-mighty-intro]": () => import("./modules/mightyRedIntro"),
};

export default (scope) => {
    Object.keys(modules).forEach((selector) => {
        const elements = scope.querySelectorAll(selector);
        if (elements && elements.length) {
            const request = modules[selector];
            request().then(({ default: module }) => module(elements));
        }
    });
};
